import styled from 'styled-components';
import { PropertyCardMenuPopperMixin } from '../../mixins/components/PropertyCardMenuPopperMixin';
import { MenuPopper } from '../MenuPopper/MenuPopper';
export var StyledPropertyCardMenuPopper = /*#__PURE__*/styled(MenuPopper).withConfig({
  displayName: "StyledPropertyCardMenuPopper",
  componentId: "c11n-8-111-1__sc-at0zrq-0"
})(["", ""], PropertyCardMenuPopperMixin);